var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/kine.bc0e56df.png","uri@2x": __webpack_public_path__ + "static/media/kine.1ac65d14.png","uri@3x": __webpack_public_path__ + "static/media/kine.c9a2ffa2.png",
    width: 50,
    height: 47
});